export enum Role {
  Admin = "Admin",
  Computer = "Computer",
  Assistant = "Assistant",
  Grid = "Grid",
  Start = "Start",
  GateMarshal = "Gate Marshal",
  Instructor = "Instructor",

  Preregistration = "Preregistration",
  Unrestricted = "Unrestricted",
  Restricted = "Restricted",
}
